import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { DiscountPolicy } from 'src/features/discountPolicies/utils/types';
import { DiscountPolicyFormSchemaValues } from 'src/features/discountPolicies/utils/formSchema';

const RESOURCE = '/discounts/discount-policy/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: DiscountPolicyFormSchemaValues): Promise<DiscountPolicy> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateDiscountPolicy };
